import AbstractChannel from './AbstractChannel'

export default class Rightway extends AbstractChannel {

  name = 'parkway_parking'
  title = 'Rightway (formerly ParkWay)'
  titleShort = 'Rightway'
  color = '#8C564B'

  supportedFeatures = ['blackouts']

}
